/** userId-first ownership: prefer stable ids, fall back to display name. */
export function isSheetOwner(sheet, participantName, userId) {
    if (userId && sheet.ownerId) {
        return sheet.ownerId === userId;
    }
    return sheet.ownerName === participantName;
}
/** GM may mutate any sheet; a player may mutate only their own PC sheet. */
export function canModifySheet(sheet, role, participantName, userId) {
    if (role === 'gm')
        return true;
    return sheet.sheetType === 'pc' && isSheetOwner(sheet, participantName, userId);
}
